import { Select } from '@mantine/core';
import { useListOrganizations } from 'api/resource';
import { Organization, Site } from 'interfaces';
import { useEffect } from 'react';

interface AdminSiteSelectorProps {
  setOrganizations: React.Dispatch<React.SetStateAction<Organization[]>>;
  setFetchOrganizations: React.Dispatch<React.SetStateAction<boolean>>;
  handleSiteChange: (value: string | null) => void;
  isAdmin: boolean;
  setSites: React.Dispatch<React.SetStateAction<Site[]>>;
  selectedSiteID: string;
}

export const AdminSiteSelector: React.FC<AdminSiteSelectorProps> = ({
  handleSiteChange,
  isAdmin,
  setOrganizations,
  setFetchOrganizations,
  setSites,
  selectedSiteID,
}) => {
  const { data: organizations = [], isFetched: fetchedOrganizations } =
    useListOrganizations({
      isAdmin,
      organizationID: '',
    });
  useEffect(() => {
    if (organizations.length) {
      setOrganizations(organizations);
      setFetchOrganizations(fetchedOrganizations);
      setSites(organizations.flatMap((org) => org.sites));
    }
  }, [organizations, fetchedOrganizations]);

  return (
    <>
      <Select
        data={organizations.map((organization) => ({
          group: organization.name,
          items: organization.sites.map((site) => ({
            label: site.name,
            value: site.id,
          })),
        }))}
        clearable
        placeholder="Select Site"
        data-testid="siteMultiSelect"
        disabled={organizations.length === 0 || !fetchedOrganizations}
        allowDeselect
        value={selectedSiteID}
        onChange={handleSiteChange}
        onClear={() => handleSiteChange(null)}
        miw="25%"
      />
    </>
  );
};
